<template>
  <div class="header-spotlight">
    <section class="header-spotlight-content">
      <h1 v-if="title">{{ title }}</h1>
      <slot />
    </section>
    <img :src="require('@/assets/images/topo_base.png')" />
  </div>
</template>

<script>
export default {
  name: 'HeaderSpotlight',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
  .header-spotlight{
    display: flex;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 305px;
    padding: 0;
    background-image: linear-gradient(
      135deg,
      var(--color-secondary),
      var(--color-secondary-dark)
    );
    justify-content: center;
    align-items: stretch;
  }
  .header-spotlight-content{
    width: 100%;
    height: 180px;
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;
    margin-top: 70px;
  }
  h1{
    color: white;
    text-shadow: 2px 2px 4px var(--color-secondary);
  }
  .header-spotlight img{
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    object-fit: cover;
  }
  @media only screen and (min-width: 600px) and (max-width: 900px) {
    .header-spotlight-content{
      width: 600px;
    }
  }

  @media only screen and (min-width: 900px) {
    .header-spotlight-content{
      width: 900px;
    }
  }
</style>
